module.exports = __webpack_public_path__ + "images/129_320.jpg";